import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('IdAndName')
export class IdAndName {
  @JsonProperty('id', Number, true) id: number = undefined;
  @JsonProperty('name', String, true) name: string = undefined;
}
